<template>
  <div>
    <router-link class="addroot" :to="{ path: '/NewRootNode' }">
      - New Root Node
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Comp_NewRootNode',
  props: [],
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>

  .addroot {
    font-size: 16px;
    text-decoration: none;
    color: cornflowerblue;
  }
</style>



// WEBPACK FOOTER //
// src/Comp_NewRootNode.vue